import React, { useState } from 'react';
import { Tabs } from 'antd';
import { 
  SettingOutlined,
  GlobalOutlined,
  BellOutlined,
  DatabaseOutlined,
  ApiOutlined,
  SafetyOutlined,
  CloudOutlined
} from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import configuration tabs
import GeneralSettings from './components/GeneralSettings';
import BrandingSettings from './components/BrandingSettings';
import NotificationSettings from './components/NotificationSettings';
import DataRetentionSettings from './components/DataRetentionSettings';
import IntegrationSettings from './components/IntegrationSettings';
import SecuritySettings from './components/SecuritySettings';
import BackupSettings from './components/BackupSettings';

const SystemConfiguration: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('general');

  const tabItems = [
    {
      key: 'general',
      label: (
        <span>
          <GlobalOutlined />
          General
        </span>
      ),
      children: <GeneralSettings />,
    },
    {
      key: 'branding',
      label: (
        <span>
          <SettingOutlined />
          Branding
        </span>
      ),
      children: <BrandingSettings />,
    },
    {
      key: 'notifications',
      label: (
        <span>
          <BellOutlined />
          Notifications
        </span>
      ),
      children: <NotificationSettings />,
    },
    {
      key: 'data-retention',
      label: (
        <span>
          <DatabaseOutlined />
          Data Retention
        </span>
      ),
      children: <DataRetentionSettings />,
    },
    {
      key: 'integrations',
      label: (
        <span>
          <ApiOutlined />
          Integrations
        </span>
      ),
      children: <IntegrationSettings />,
    },
    {
      key: 'security',
      label: (
        <span>
          <SafetyOutlined />
          Security
        </span>
      ),
      children: <SecuritySettings />,
    },
    {
      key: 'backup',
      label: (
        <span>
          <CloudOutlined />
          Backup
        </span>
      ),
      children: <BackupSettings />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<SettingOutlined />}
        title="System Configuration"
        subtitle="Configure system settings, integrations, security, and operational parameters"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default SystemConfiguration; 